import { Link as RouterLink, useLocation } from 'react-router-dom';
// @mui
import { Box, Grid, Link, Stack, Divider, Container, Typography, IconButton } from '@mui/material';
// routes
import { PATH_PAGE } from '../../routes/paths';
// utils
import { isCOMDomain } from '../../utils/address';
// _mock
import { _socials } from '../../_mock/arrays';
// components
import Logo from '../../components/logo';
import Iconify from '../../components/iconify';

// ----------------------------------------------------------------------

const LINKS = [
  {
    headline: 'Learmonade',
    children: [
      { name: 'About us', href: PATH_PAGE.about },
      ...(!isCOMDomain() ? [{ name: 'Contact us', href: PATH_PAGE.contact }] : []),
      { name: 'FAQs', href: PATH_PAGE.faqs },
    ],
  },
  {
    headline: 'Legal',
    children: [
      { name: 'Terms and Condition', href: PATH_PAGE.comingSoon },
      { name: 'Privacy Policy', href: PATH_PAGE.comingSoon },
    ],
  },
  {
    headline: 'Contact',
    children: [
      { name: 'support@learmonade.com', href: 'mailto:support@learmonade.com' },
      ...(isCOMDomain() ? [{ name: 'Hong Kong', href: '#' }] : []),
    ],
  },
];

// ----------------------------------------------------------------------

export default function Footer() {
  const { pathname } = useLocation();

  const isHome = pathname === '/';
  const isCOM = isCOMDomain();

  const mainFooter = (
    <Box
      component="footer"
      sx={{
        position: 'relative',
        bgcolor: 'background.default',
      }}
    >

      {!isHome && <Divider />}
      
      <Container sx={{ pt: 10 }}>
        <Grid
          container
          justifyContent={{
            xs: 'center',
            md: 'space-between',
          }}
          sx={{
            textAlign: {
              xs: 'center',
              md: 'left',
            },
          }}
        >
          <Grid item xs={12} sx={{ mb: 3 }}>
            <Logo sx={{ mx: { xs: 'auto', md: 'inherit' } }} />
          </Grid>

          <Grid item xs={8} md={3}>
            <Typography variant="body2" sx={{ pr: { md: 5 } }}>
              The starting point for your language learning | Learmonade ©
            </Typography>

            <Stack
              spacing={1}
              direction="row"
              justifyContent={{ xs: 'center', md: 'flex-start' }}
              sx={{
                mt: 5,
                mb: { xs: 5, md: 0 },
              }}
            >
              {_socials.map((social) => (
                <IconButton key={social.name}>
                  <Iconify icon={social.icon} />
                </IconButton>
              ))}
            </Stack>
          </Grid>

          <Grid item xs={12} md={7}>
            <Stack
              spacing={5}
              justifyContent="space-between"
              direction={{ xs: 'column', md: 'row' }}
            >
              {LINKS.map((list) => (
                <Stack
                  key={list.headline}
                  spacing={2}
                  alignItems={{ xs: 'center', md: 'flex-start' }}
                >
                  <Typography component="div" variant="overline">
                    {list.headline}
                  </Typography>

                  {list.children.map((link) => (
                    <Link
                      key={link.name}
                      component={RouterLink}
                      to={link.href}
                      color="inherit"
                      variant="body2"
                    >
                      {link.name}
                    </Link>
                  ))}
                </Stack>
              ))}
            </Stack>
          </Grid>
        </Grid>

        <Typography
          variant="caption"
          component="div"
          sx={{
            pb: 5,
            mt: { xs: 5, md: 10 },
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          {
            isCOM ? '© 2023. All rights reserved' : (
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={0.8}>
                <Link
                href="https://beian.miit.gov.cn/"
                target="_blank"
                rel="noreferrer"
                sx={{
                  cursor: 'pointer',
                  color: 'text.primary',
                  '&:hover': {
                    textDecoration: 'none',
                    color: 'primary.main',
                  }
                }}>粤ICP备2025429439号</Link>
                <Box  sx={{
                  display: { xs: 'none', sm: 'block' },
                }}>|</Box>
                <Link
                  href="https://beian.mps.gov.cn/#/query/webSearch?code=44030002007212"
                  target="_blank"
                  rel="noreferrer"
                  sx={{
                    cursor: 'pointer',
                    color: 'text.primary',
                    '&:hover': {
                      textDecoration: 'none',
                      color: 'primary.main',
                    }
                  }}>粤公网安备44030002007212号</Link>
              </Stack>
            )
          }
        </Typography>
      </Container>
    </Box>
  );

  return mainFooter;
}
